import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/auth/views/Login";

const router = require('air-vue-model/router')

const routes = [

    {
        path: '/login',
        name: 'login',
        component: Login,
    },
]

export default router(Vue, VueRouter, routes)
